import { Component, input } from '@angular/core';
import { IconName, provideIcons } from '@ng-icons/core';
import { lucidePlus } from '@ng-icons/lucide';
import { HlmIconImports } from '@spartan-ng/helm/icon';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  providers: [provideIcons({ lucidePlus })],
  imports: [HlmIconImports],
})
export class EmptyStateComponent {
  readonly title = input.required<string>();
  readonly icone = input<IconName>();
}
